import React from 'react'

export default function Divider() {
    return (
        <div>
            <center>
                <div style={{
                    width: "40px",
                    height: "6px",
                    background: "#0d6efd",
                    margin: "15px"
                }}></div>
            </center>
        </div>
    )
}
